import { render, staticRenderFns } from "./AddDealerDialog.vue?vue&type=template&id=1f58e4ae&scoped=true"
import script from "./AddDealerDialog.vue?vue&type=script&lang=js"
export * from "./AddDealerDialog.vue?vue&type=script&lang=js"
import style0 from "./AddDealerDialog.vue?vue&type=style&index=0&id=1f58e4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f58e4ae",
  null
  
)

export default component.exports